import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { scrollIntoView } from "../../constants/utilityFunctions";

// Actions
import { setSelectorPosition } from "../../actions";
import { locationTriangleOffsetPixels } from "../../constants/constants";
import List from "@material-ui/core/List";
import Location from "./Location";
import { customTheme } from "../../constants/customTheme";

function LocationsList(props) {
  const useStyles = makeStyles({
    locationList: {
      padding: 0,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
    },
    simpleBar: {
      flex: "1 1 auto",
      minHeight: 0,
      overflowY: "auto",
      ...customTheme().customScrollBar,
    },
  });

  let locationsList = React.createRef();
  let simpleBar = React.createRef();

  // runs on every rerender
  useEffect(() => {
    // dont want this to run in BODY_MAP mode
    if (props.currentLocationView === "LIST") {
      moveSelectorToSelected();
    } else {
      hideSelector();
    }
  });

  // moves triangle to currently selected position
  const moveSelectorToSelected = () => {
    // find currently selected DOM node programatically
    // use ref for location list to narrow search - then target selected class
    const selected = locationsList.current.getElementsByClassName(
      "Mui-selected"
    );
    if (selected.length > 0) {
      // move selector to DOM node
      const offsetTop = selected[0].offsetTop;
      const height = selected[0].clientHeight;
      const trianglePosition = offsetTop + height / 2;
      // only update if value needs to change
      // otherwise in an infinite loop as changes to state trigger a rerender
      // and rerenders trigger useEffect()
      if (
        trianglePosition + locationTriangleOffsetPixels !==
          props.selectorPosition &&
        !props.leftView
      ) {
        props.dispatch(
          setSelectorPosition(trianglePosition + locationTriangleOffsetPixels)
        );
      }
      scrollIntoView(selected[0], simpleBar.current);
      props.handleScroll(simpleBar.current.scrollTop);
    } else {
      // if nothing is selected hide the arrow
      hideSelector();
    }
  };

  const hideSelector = () => {
    props.dispatch(setSelectorPosition(-20));
  };

  const classes = useStyles();

  return (
    <React.Fragment>
      <List
        component="nav"
        aria-label="Acquisition List"
        className={classes.locationList}
        ref={locationsList}
      >
        <div
          className={classes.simpleBar}
          ref={simpleBar}
          id="my_sc"
          onScroll={(e) => {
            if (!props.leftView) {
              props.handleScroll(e.target.scrollTop);
            }
          }}
        >
          {props.locationIds.map((id) => {
            return (
              <Location
                key={id}
                id={id}
                selected={id === props.selectedLocationId}
              />
            );
          })}
        </div>
      </List>
    </React.Fragment>
  );
}

// this uses the reselect library
// memoizes the (expensive) filter calculation and only updates it when one of its input variables changes
const filterLocations = createSelector(
  [
    (state) => state.locations.allIds,
    (state) => state.utility.showCompleted,
    (state) => state.locations.byId,
  ],
  (locationIds, showCompleted, locationsById) => {
    if (showCompleted) {
      return locationIds;
    } else {
      return locationIds.filter((locationId) => {
        return !locationsById[locationId].completed;
      });
    }
  }
);

const mapStateToProps = (state) => {
  return {
    allIds: state.locations.allIds,
    currentLocationView: state.locations.currentLocationView,
    selectorPosition: state.locations.selectorPosition,
    selectedLocationId: state.locations.selectedLocationId,
    locationIds: filterLocations(state),
    leftView: state.view.mainViewSection.orientation === "LEFT",
  };
};

export default connect(mapStateToProps)(LocationsList);
